import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { TableIt } from "../../components/budget/it/TableIt";
import { useEffect, useState } from "react";
import {
  SAVE_CATEGORY_IT,
  SAVE_DATA_IT,
} from "../../utils/savedDataConstant/ItSaveConstants";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";

export const InputIt = () => {
  const [saveData, setSaveData] = useState([]);
  const arrayData = SAVE_DATA_IT;
  const save_name_category = SAVE_CATEGORY_IT;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData.filter(Boolean).map((d) => ({
        activityName: "OVH",
        siteId: d.siteId,
        theme: d.theme,
        months: d.months,
      }));
      sendToFinancialData(modifiedData, save_name_category);
    }
  }, [saveData]);

  return (
    <BaseBudgetInput
      title="Input IT"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_IT}
      enableFlag="dataEntryEnableIt"
      TableComponent={TableIt}
      tableComponentProps={{
        params,
      }}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={arrayData}
      saveNameCategory={save_name_category}
      onParamsChange={setParams}
    />
  );
};
